export const cryptos = [
  { id: '2', symbol: 'ETHUSD' },
  { id: '3', symbol: 'XRPUSD' },
  { id: '6', symbol: 'BCHUSD' },
  { id: '9', symbol: 'XLMUSD' },
  { id: '10', symbol: 'BNBUSD' },
  { id: '8', symbol: 'DOTUSD' },
  { id: '7', symbol: 'ADAUSD' },
  { id: '1', symbol: 'BTCUSD' },
  { id: '4', symbol: 'LTCUSD' },
  { id: '5', symbol: 'DOGEUSD' },
];

export const categories = [
  { path: 'forex', category: 'Forex', market_cap: '$6.6 T' },
  { path: 'majors', category: 'Majors', market_cap: '$6.6 T' },
  { path: 'crypto', category: 'Cryptos', market_cap: '$2,78 T' },
  { path: 'stocks', category: 'Stocks', market_cap: ' $48,56 M' },
  { path: 'efts', category: 'ETF iShares', market_cap: '$325.43 B' },
];
